"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _HotelCard = require("./HotelCard.proptypes");
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _Timer = _interopRequireDefault(require("@airasia/phoenix-components/components/Timer"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _super_certified = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon/statics/super_certified"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _PriceDetails = _interopRequireDefault(require("./PriceDetails"));
var _HotelInfo = _interopRequireDefault(require("./HotelInfo"));
var _ImageCarousel = _interopRequireDefault(require("@airasia/phoenix-components/components/ImageCarousel"));
var _constant = require("../Card/constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Container = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__Container",
  componentId: "sc-mub93g-0"
})(["", ";max-width:", ";box-shadow:0 1px 4px rgba(0,0,0,0.16);border-radius:4px;", " font-family:", ";cursor:pointer;", ";", ";"], function (_ref) {
  var isMobile = _ref.isMobile,
    isCarouselCard = _ref.isCarouselCard;
  return !isCarouselCard && (!isMobile ? 'min-height: 216px' : 'min-height: 320px');
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '100%' : '912px';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.default;
}, function (_ref5) {
  var templateType = _ref5.templateType;
  return templateType === _constant.TEMPLATE_TYPE.HOTEL_CARD ? ' padding-left: 15px;' : '';
}, function (_ref6) {
  var isCarouselCard = _ref6.isCarouselCard;
  return isCarouselCard && 'height: 550px;';
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__Wrapper",
  componentId: "sc-mub93g-1"
})(["height:100%;display:flex;position:relative;", ";", " ", " ", ";"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return !isMobile ? 'min-height: 216px' : 'min-height: 320px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref9) {
  var isMobile = _ref9.isMobile,
    highlight = _ref9.highlight,
    theme = _ref9.theme;
  return highlight && !isMobile ? "\n    border: 1px solid ".concat(theme.colors.secondary, ";\n    border-radius: 0 0 ").concat(theme.space.micro, " ").concat(theme.space.micro, ",\n    border-top: 0,\n    ") : "";
}, function (_ref10) {
  var isCarouselCard = _ref10.isCarouselCard;
  return isCarouselCard && 'justify-content: space-between';
});
var HighlightBar = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__HighlightBar",
  componentId: "sc-mub93g-2"
})(["width:100%;background:", ";border-radius:", ";display:block !important;box-sizing:border-box;padding:", ";min-height:40px;color:", ";font-size:", ";line-height:", ";display:flex;"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.secondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space.tiny, " ").concat(theme.space.small);
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.default;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.small;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.XLarge;
});
var CarouselWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__CarouselWrapper",
  componentId: "sc-mub93g-3"
})(["width:", ";", " ", ";"], function (_ref17) {
  var isMobile = _ref17.isMobile;
  return isMobile ? '100%' : '24%';
}, function (_ref18) {
  var isMobile = _ref18.isMobile;
  return isMobile && 'height: 150px;';
}, function (_ref19) {
  var isCarouselCard = _ref19.isCarouselCard;
  return isCarouselCard && 'height: 40%;';
});
var HotelDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__HotelDetailsWrapper",
  componentId: "sc-mub93g-4"
})(["width:", ";", ";", ";display:flex;flex-direction:column;justify-content:space-evenly;"], function (_ref20) {
  var isMobile = _ref20.isMobile;
  return isMobile ? '100%' : '60%';
}, function (_ref21) {
  var isCarouselCard = _ref21.isCarouselCard;
  return isCarouselCard && 'height: 30%;';
}, function (_ref22) {
  var isCarouselCard = _ref22.isCarouselCard;
  return !isCarouselCard && 'border-left: 1px solid #ededed;';
});
var LeftContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__LeftContainer",
  componentId: "sc-mub93g-5"
})(["font-size:20px;display:flex;margin-right:10px;justify-content:space-between;align-items:center;"]);
var RightContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__RightContainer",
  componentId: "sc-mub93g-6"
})(["font-size:20px;margin-right:10px;display:flex;justify-content:space-between;align-items:center;"]);
var HighlightFomoWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__HighlightFomoWrapper",
  componentId: "sc-mub93g-7"
})(["background-color:", ";display:flex;justify-content:space-between;align-items:center;color:white;min-height:42px;border-radius:", ";> *{font-size:", ";}"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.primary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.borderRadius.normal;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontSize.XSmall;
});
var TimerWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TimerWrapper",
  componentId: "sc-mub93g-8"
})(["background-color:", ";display:flex;justify-content:center;align-items:center;color:", ";min-height:42px;border-radius:", ";> *{font-size:", ";}"], function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.primaryLight;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.primary;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.borderRadius.normal;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.fontSize.XSmall;
});
var TimerIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TimerIconWrapper",
  componentId: "sc-mub93g-9"
})(["margin-right:", ";margin-left:", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.space.tiny;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.space.tiny;
});
var TimeCounter = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TimeCounter",
  componentId: "sc-mub93g-10"
})(["margin-left:", ";"], function (_ref32) {
  var theme = _ref32.theme;
  return theme.space.tiny;
});
var TextDashContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__TextDashContainer",
  componentId: "sc-mub93g-11"
})(["margin-left:", ";margin-right:", ";"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.space.tiny;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.space.tiny;
});
var PriceDetailsWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__PriceDetailsWrapper",
  componentId: "sc-mub93g-12"
})(["width:", ";", ";", ";", ";"], function (_ref35) {
  var isMobile = _ref35.isMobile;
  return isMobile ? '100%' : '20%';
}, function (_ref36) {
  var isCarouselCard = _ref36.isCarouselCard;
  return !isCarouselCard && 'border-left: 1px solid #ededed;';
}, function (_ref37) {
  var isCarouselCard = _ref37.isCarouselCard;
  return isCarouselCard && 'padding-bottom: 10px;';
}, function (_ref38) {
  var isCarouselCard = _ref38.isCarouselCard,
    strikethroughPresent = _ref38.strikethroughPresent;
  return isCarouselCard && !strikethroughPresent && 'margin-top: 36px;';
});
var NoRoomAvailableWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__NoRoomAvailableWrapper",
  componentId: "sc-mub93g-13"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:100%;"]);
var PLACEHOLDER_IMAGE = 'https://static.airasia.com/snap/images/hotel_image_holder.svg';
var BucketTitleWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__BucketTitleWrapper",
  componentId: "sc-mub93g-14"
})(["padding-top:8px;padding-bottom:8px;display:flex;align-items:center;justify-content:center;height:5%;"]);
var PromoWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__PromoWrapper",
  componentId: "sc-mub93g-15"
})(["display:flex;justify-content:center;align-items:center;margin-left:auto;background:#ededf6;width:max-content;height:28px;font-style:normal;font-weight:500;font-size:12px;line-height:150%;", ";", ";"], function (_ref39) {
  var isMobile = _ref39.isMobile;
  return !isMobile && 'padding: 4px 12px';
}, function (_ref40) {
  var isMobile = _ref40.isMobile;
  return isMobile && 'border-radius: 4px';
});
var PromoTag = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__PromoTag",
  componentId: "sc-mub93g-16"
})(["width:", ";height:", ";padding-left:", ";", ";"], function (_ref41) {
  var isMobile = _ref41.isMobile;
  return isMobile ? '18px' : '26px';
}, function (_ref42) {
  var isMobile = _ref42.isMobile;
  return isMobile ? '18px' : '26px';
}, function (_ref43) {
  var isMobile = _ref43.isMobile;
  return isMobile ? '16px' : '24px';
}, function (_ref44) {
  var isMobile = _ref44.isMobile;
  return isMobile && 'padding-top: 12px';
});
var Tile = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__Tile",
  componentId: "sc-mub93g-17"
})(["position:absolute;z-index:1;top:11px;left:12px;width:48px;height:48px;display:flex;justify-content:center;align-items:center;box-sizing:border-box;"]);
var PromoTagWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__PromoTagWrapper",
  componentId: "sc-mub93g-18"
})(["display:flex;align-items:center;width:max-content;margin-top:", ";margin-left:", ";"], function (_ref45) {
  var isMobile = _ref45.isMobile;
  return isMobile ? '8px' : '0px';
}, function (_ref46) {
  var isMobile = _ref46.isMobile;
  return isMobile ? '-10px' : '0px';
});
var FlyerDiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelCard__FlyerDiscountWrapper",
  componentId: "sc-mub93g-19"
})(["display:flex;justify-content:center;align-items:center;margin-left:", ";background:", ";width:max-content;height:28px;font-style:normal;font-weight:500;font-size:12px;line-height:150%;", ";"], function (_ref47) {
  var promoTag = _ref47.promoTag;
  return promoTag ? '10px' : '0px';
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.colors.primaryLight;
}, function (_ref49) {
  var isMobile = _ref49.isMobile;
  return isMobile ? 'border-radius: 4px' : 'padding: 4px 12px';
});
var HotelCard = function HotelCard(_ref50) {
  var accessible = _ref50.accessible,
    salesTag = _ref50.salesTag,
    bigPointPromo = _ref50.bigPointPromo,
    images = _ref50.images,
    discountText = _ref50.discountText,
    discountType = _ref50.discountType,
    strikeThrough = _ref50.strikeThrough,
    price = _ref50.price,
    totalPrice = _ref50.totalPrice,
    promoTag = _ref50.promoTag,
    hilightText = _ref50.hilightText,
    amenities = _ref50.amenities,
    promoTitle = _ref50.promoTitle,
    starRating = _ref50.starRating,
    hotelName = _ref50.hotelName,
    location = _ref50.location,
    distance = _ref50.distance,
    reviews = _ref50.reviews,
    tripAdvisorReviews = _ref50.tripAdvisorReviews,
    theme = _ref50.theme,
    translations = _ref50.translations,
    isMobile = _ref50.isMobile,
    facilities = _ref50.facilities,
    heroImage = _ref50.heroImage,
    onLoadImage = _ref50.onLoadImage,
    isImageCarouselEnabled = _ref50.isImageCarouselEnabled,
    onClick = _ref50.onClick,
    highlight = _ref50.highlight,
    time = _ref50.time,
    DoDLableFirst = _ref50.DoDLableFirst,
    isDoDEnabled = _ref50.isDoDEnabled,
    DoDLableSecond = _ref50.DoDLableSecond,
    locale = _ref50.locale,
    bucketTitle = _ref50.bucketTitle,
    templateType = _ref50.templateType,
    debug = _ref50.debug,
    fomoLabel = _ref50.fomoLabel,
    isFomoTimerEnabled = _ref50.isFomoTimerEnabled,
    isCarouselCard = _ref50.isCarouselCard,
    expandCarouselArrowClickableArea = _ref50.expandCarouselArrowClickableArea,
    fomoTime = _ref50.fomoTime,
    certifiedSuperTitel = _ref50.certifiedSuperTitel,
    gaIdExperimentValue = _ref50.gaIdExperimentValue,
    isComboSavingsTagEnabled = _ref50.isComboSavingsTagEnabled,
    savingsAmount = _ref50.savingsAmount,
    selectRoomLabel = _ref50.selectRoomLabel,
    withSelectRoom = _ref50.withSelectRoom,
    isHotelNotAvailable = _ref50.isHotelNotAvailable,
    bigPoint = _ref50.bigPoint,
    isHotel = _ref50.isHotel,
    isPromoEnabled = _ref50.isPromoEnabled,
    promoText = _ref50.promoText,
    promoHoverText = _ref50.promoHoverText,
    BogoTag = _ref50.BogoTag,
    isBogoPromoEnabled = _ref50.isBogoPromoEnabled,
    bogoMessage = _ref50.bogoMessage,
    move = _ref50.move,
    flyerDiscountLabel = _ref50.flyerDiscountLabel,
    isRM9PromoEnabled = _ref50.isRM9PromoEnabled,
    pricebreakdownData = _ref50.pricebreakdownData,
    handleMouseEnter = _ref50.handleMouseEnter,
    handleMouseLeave = _ref50.handleMouseLeave,
    comboSavingsData = _ref50.comboSavingsData,
    isComboSavingsPopUpEnabled = _ref50.isComboSavingsPopUpEnabled,
    snapSummaryMultipax = _ref50.snapSummaryMultipax,
    baseRate = _ref50.baseRate,
    isMapView = _ref50.isMapView;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fomoEndTime = _useState2[0],
    setFomoEndTime = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    fomoTimeDod = _useState4[0],
    setFomoTimeDod = _useState4[1];
  var handleTimer = function handleTimer() {
    setFomoEndTime(null);
  };
  var handleTimerDod = function handleTimerDod() {
    setFomoTimeDod(null);
  };
  var formatStringDate = function formatStringDate(dateToFormat) {
    return "".concat((0, _format.default)(dateToFormat, 'yyyy-MM-dd'), "T").concat((0, _format.default)(dateToFormat, 'HH:mm:ss'));
  };
  (0, _react.useEffect)(function () {
    if (fomoTime) {
      try {
        var currentDateTime = new Date();
        var fomoTimeSplit = fomoTime.split(':');
        currentDateTime.setHours(currentDateTime.getHours() + Number(fomoTimeSplit[0]));
        currentDateTime.setMinutes(currentDateTime.getMinutes() + Number(fomoTimeSplit[1]));
        currentDateTime.setSeconds(currentDateTime.getSeconds() + Number(fomoTimeSplit[2]));
        setFomoEndTime(formatStringDate(currentDateTime));
      } catch (error) {
        setFomoEndTime(null);
      }
    }
  }, [fomoTime]);
  (0, _react.useEffect)(function () {
    if (time) {
      try {
        var currentDateTime = new Date();
        var fomoTimeSplit = time.split(':');
        currentDateTime.setHours(currentDateTime.getHours() + Number(fomoTimeSplit[0]));
        currentDateTime.setMinutes(currentDateTime.getMinutes() + Number(fomoTimeSplit[1]));
        currentDateTime.setSeconds(currentDateTime.getSeconds() + Number(fomoTimeSplit[2]));
        setFomoTimeDod(formatStringDate(currentDateTime));
      } catch (error) {
        setFomoTimeDod(null);
      }
    }
  }, [time]);
  var onClickCalled = function onClickCalled(e) {
    e.preventDefault();
    onClick();
  };
  var getMain = function getMain(_ref51) {
    var imageList = _ref51.imageList;
    return /*#__PURE__*/_react.default.createElement(Container, {
      tabIndex: tabIndex,
      onClick: onClickCalled,
      isMobile: isMobile,
      templateType: templateType,
      isCarouselCard: isCarouselCard
    }, highlight && /*#__PURE__*/_react.default.createElement(HighlightBar, {
      className: "highlight-bar"
    }, hilightText), isDoDEnabled && fomoTimeDod && /*#__PURE__*/_react.default.createElement(HighlightFomoWrapper, null, /*#__PURE__*/_react.default.createElement(LeftContainer, null, /*#__PURE__*/_react.default.createElement(TimerIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "TimerIcon",
      fontsize: "normal",
      color: "white"
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "white",
      accessible: accessible,
      theme: theme
    }, DoDLableFirst)), /*#__PURE__*/_react.default.createElement(RightContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "white",
      accessible: accessible,
      theme: theme
    }, DoDLableSecond), /*#__PURE__*/_react.default.createElement(TimeCounter, null, /*#__PURE__*/_react.default.createElement(_Timer.default, {
      accessible: true,
      allowLocaleFormat: false,
      color: "white",
      dayLabel: "days",
      endDate: fomoTimeDod,
      localeConfig: {
        hour: 'numeric',
        hour12: false,
        minute: 'numeric',
        second: 'numeric'
      },
      size: "Small",
      theme: "AIRASIA_CLASSIC",
      timeEndCallback: handleTimerDod
    })))), /*#__PURE__*/_react.default.createElement(Wrapper, {
      tabIndex: tabIndex,
      isMobile: isMobile,
      highlight: highlight,
      isCarouselCard: isCarouselCard
    }, bucketTitle && /*#__PURE__*/_react.default.createElement(BucketTitleWrapper, null, bucketTitle), discountType === 'certified_super' && /*#__PURE__*/_react.default.createElement(Tile, {
      "aria-label": "certified_super",
      title: certifiedSuperTitel
    }, /*#__PURE__*/_react.default.createElement(_super_certified.default, {
      fontsize: "titleNormal",
      themeColor: "default",
      "aria-label": "certified_super_icon",
      title: certifiedSuperTitel
    })), /*#__PURE__*/_react.default.createElement(CarouselWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard
    }, !isImageCarouselEnabled ? /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage,
      width: "100%",
      height: "100%",
      onLoad: onLoadImage,
      centerFocus: true,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: PLACEHOLDER_IMAGE
    }) : /*#__PURE__*/_react.default.createElement(_ImageCarousel.default, {
      responsive: [{
        breakPoint: 0,
        cardsToShow: 1
      }],
      infinite: true,
      expandCarouselArrowClickableArea: expandCarouselArrowClickableArea
    }, imageList.map(function (image) {
      return /*#__PURE__*/_react.default.createElement(_Image.default, {
        key: image,
        src: image,
        width: "100%",
        height: "100%",
        onLoad: onLoadImage,
        centerFocus: true,
        enableProgressiveImageLoading: true,
        lowResolutionImageUrl: PLACEHOLDER_IMAGE
      });
    }))), /*#__PURE__*/_react.default.createElement(HotelDetailsWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard
    }, highlight && /*#__PURE__*/_react.default.createElement(PromoTag, null, /*#__PURE__*/_react.default.createElement(PromoTagWrapper, {
      isMobile: isMobile
    }, promoTag && /*#__PURE__*/_react.default.createElement(PromoWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "secondaryLight",
      textColor: "secondaryDark",
      theme: theme
    }, promoTag)), flyerDiscountLabel && /*#__PURE__*/_react.default.createElement(FlyerDiscountWrapper, {
      isMobile: isMobile,
      promoTag: promoTag
    }, /*#__PURE__*/_react.default.createElement(_Label.default, {
      labelColor: "primaryLight",
      textColor: "primaryDark",
      theme: theme
    }, flyerDiscountLabel)))), /*#__PURE__*/_react.default.createElement(_HotelInfo.default, {
      promoTag: promoTag,
      promoTitle: promoTitle,
      freeCancellationText: translations === null || translations === void 0 ? void 0 : translations.freeCancellationText,
      carouselFreeCancellation: translations === null || translations === void 0 ? void 0 : translations.carouselFreeCancellation,
      payLaterText: translations === null || translations === void 0 ? void 0 : translations.payLaterText,
      payAtHotelText: translations === null || translations === void 0 ? void 0 : translations.payAtHotelText,
      lowInventoryAlert: translations === null || translations === void 0 ? void 0 : translations.lowInventoryAlert,
      fomoMessage: translations === null || translations === void 0 ? void 0 : translations.fomoMessage,
      amenities: amenities,
      starRating: starRating,
      isCarouselCard: isCarouselCard,
      debug: debug,
      hotelName: hotelName,
      location: location,
      distance: distance,
      reviews: reviews,
      tripAdvisorReviews: tripAdvisorReviews,
      setAmenityFocused: false,
      title: translations === null || translations === void 0 ? void 0 : translations.amenityTitle,
      theme: theme,
      isMobile: isMobile,
      highlight: highlight,
      templateType: templateType,
      reviewTranslation: translations === null || translations === void 0 ? void 0 : translations.reviewTranslation,
      discountType: discountType,
      isHotelNotAvailable: isHotelNotAvailable,
      noHotelsAvailableWarning: translations === null || translations === void 0 ? void 0 : translations.noHotelsAvailableWarning,
      isPromoEnabled: isPromoEnabled,
      promoText: promoText,
      promoHoverText: promoHoverText,
      bogoMessage: bogoMessage,
      isBogoPromoEnabled: isBogoPromoEnabled,
      payNowText: translations === null || translations === void 0 ? void 0 : translations.payNowText,
      move: move,
      flyerDiscountLabel: flyerDiscountLabel,
      isRM9PromoEnabled: isRM9PromoEnabled,
      isHotel: isHotel
    })), /*#__PURE__*/_react.default.createElement(PriceDetailsWrapper, {
      isMobile: isMobile,
      isCarouselCard: isCarouselCard,
      strikethroughPresent: strikeThrough
    }, !isHotelNotAvailable && /*#__PURE__*/_react.default.createElement(_PriceDetails.default, {
      theme: theme,
      salesTag: salesTag,
      promoTag: promoTag,
      bigPointPromo: bigPointPromo,
      discountText: discountText,
      strikeThrough: strikeThrough,
      price: price,
      priceText: translations === null || translations === void 0 ? void 0 : translations.priceText,
      perGuestText: translations === null || translations === void 0 ? void 0 : translations.perGuestText,
      snapPriceText: translations === null || translations === void 0 ? void 0 : translations.snapPriceText,
      totalPrice: totalPrice,
      isMobile: isMobile,
      promoTitle: promoTitle,
      facilities: facilities,
      locale: locale,
      lowInventoryAlert: translations === null || translations === void 0 ? void 0 : translations.lowInventoryAlert,
      fomoMessage: translations === null || translations === void 0 ? void 0 : translations.fomoMessage,
      isCarouselCard: isCarouselCard,
      discountType: discountType,
      gaIdExperimentValue: gaIdExperimentValue,
      isComboSavingsTagEnabled: isComboSavingsTagEnabled,
      savingsAmount: savingsAmount,
      withSelectRoom: withSelectRoom,
      selectRoomLabel: selectRoomLabel,
      bigPoint: bigPoint,
      isHotel: isHotel,
      isBogoPromoEnabled: isBogoPromoEnabled,
      BogoTag: BogoTag,
      move: move,
      accessible: accessible,
      isRM9PromoEnabled: isRM9PromoEnabled,
      pricebreakdownData: pricebreakdownData,
      handleMouseEnter: handleMouseEnter,
      handleMouseLeave: handleMouseLeave,
      comboSavingsData: comboSavingsData,
      isComboSavingsPopUpEnabled: isComboSavingsPopUpEnabled,
      snapSummaryMultipax: snapSummaryMultipax,
      baseRate: baseRate,
      isMapView: isMapView
    }), isHotelNotAvailable && !isMobile && /*#__PURE__*/_react.default.createElement(NoRoomAvailableWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "AvTimerIcon",
      fontsize: "titleLarge",
      color: "primary"
    }), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "primary",
      accessible: accessible,
      theme: theme
    }, (translations === null || translations === void 0 ? void 0 : translations.justMissedIt) || 'Just missed it!')))), fomoEndTime && isFomoTimerEnabled && !isHotelNotAvailable && /*#__PURE__*/_react.default.createElement(TimerWrapper, null, /*#__PURE__*/_react.default.createElement(TimerIconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      accessible: accessible,
      icon: "TimerIcon",
      fontsize: "normal",
      color: "primary"
    })), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "primary",
      accessible: accessible,
      theme: theme
    }, fomoLabel), /*#__PURE__*/_react.default.createElement(TextDashContainer, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: "primary",
      accessible: accessible,
      theme: theme
    }, "-")), /*#__PURE__*/_react.default.createElement(_Timer.default, {
      accessible: true,
      allowLocaleFormat: false,
      color: "primary",
      dayLabel: "days",
      endDate: fomoEndTime,
      localeConfig: {
        hour: 'numeric',
        hour12: false,
        minute: 'numeric',
        second: 'numeric'
      },
      size: "XSmall",
      theme: "AIRASIA_CLASSIC",
      timeEndCallback: handleTimer
    })));
  };
  getMain.propTypes = _HotelCard.getMainPropType;
  return themeContext ? getMain({
    imageList: images
  }) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain({
    imageList: images
  }));
};
HotelCard.propTypes = _HotelCard.HotelCardPropTypes;
HotelCard.defaultProps = _HotelCard.HotelCardDefaultProps;
var _default = HotelCard;
exports.default = _default;